<template functional>
    <div class="bto-sb-event-odds-left">
        <div :class="[
  'bto-sb-event-time-live',
  { 'bto-sb-event-time-break' : !props.match.time}]"><span>{{props.match.time || props.match.status || '--'}}</span>
        </div>
        <div class="bto-sb-event-name-live"
             @mousemove="props.showOddPopup($event, props.getPopupTitle(props.match))"
             @mouseleave="props.hideOddPopup()">
             <router-link :to="props.openLiveMatch(props.match)">
                <span class="bto-sb-event-home-live" v-show="!props.expandedView">{{props.match.homeTeam}}</span>
                <logo-component v-if="props.showTeamIcon && !props.expandedView" v-slot="{ url, reset, onLoad, loaded }" :logo-url="props.match.homeTeamIcon" >
                  <span class="bto-sb-event-team-logo bto-sb-event-hometeam-logo" v-if="url" v-show="loaded">
                    <img :src="url" alt="" @error="reset" @load="onLoad" />
                  </span>
                </logo-component>
                <span class="bto-sb-event-score-live">
                  <span class="bto-sb-event-score-home">{{props.match.score.home}}</span>
                  <span class="bto-sb-event-score-away">{{props.match.score.away}}</span>
                </span>
                <logo-component v-if="props.showTeamIcon&& !props.expandedView" v-slot="{ url, reset, onLoad, loaded }" :logo-url="props.match.guestTeamIcon" >
                  <span class="bto-sb-event-team-logo bto-sb-event-awayteam-logo" v-if="url" v-show="loaded">
                    <img :src="url" alt="" @error="reset" @load="onLoad" />
                  </span>
                </logo-component>
                <span class="bto-sb-event-away-live" v-show="!props.expandedView">{{props.match.guestTeam}}</span>
            </router-link>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'MatchDetails',
    props: {
      match: {
        type: Object,
        required: true,
        default: () => {
        }
      },
      expandedView: {
        type: Boolean,
        default: false
      },
      showTeamIcon: {
        type: Boolean,
        default: true,
      },
      showOddPopup: {
        type: Function,
        default: () => {
        }
      },
      openLiveMatch: {
         type: Function,
         default: () => {
         }
      },
      hideOddPopup: {
        type: Function,
        default: () => {
        }
      },
      getPopupTitle: {
        type: Function,
        default: () => {
        }
      },
      hasLiveStream: {
        type: Function,
        default: () => {
        }
      }
    }
  };
</script>
